export default __webpack_public_path__ + "static/media/fi_drugs.896b52e0.png";